import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Modal } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import React, { useState } from 'react'
import { Keyboard, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { lightbox } from './Lightbox.css'

interface LightboxProps {
  assets: ReturnType<typeof mapProductPage>['product_details']['assets']
  initialSlideIndex: number
  closeCallback: () => void
}

export const Lightbox: React.FC<LightboxProps> = ({ assets, initialSlideIndex, closeCallback }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(initialSlideIndex)

  return (
    <Modal
      closeCallback={closeCallback}
      customContent={true}
      isCoral={true}
      overlayBackgroundColor={'dark'}
      position={'center'}
    >
      <div className={lightbox.swiperContainer}>
        <Swiper
          className={lightbox.swiper._}
          initialSlide={initialSlideIndex}
          keyboard={{ enabled: true }}
          modules={[Navigation, Pagination, Keyboard]}
          navigation={true}
          onSlideChange={(swiper) => setCurrentSlideIndex(swiper.realIndex)}
          pagination={{ clickable: true }}
          slidesPerView={1}
          spaceBetween={50}
        >
          {assets.map(({ thumbnail, video }, i) => (
            <SwiperSlide className={lightbox.swiper.slide} key={i}>
              <Asset
                className={lightbox.swiper.asset}
                forcePauseVideo={currentSlideIndex !== i}
                lazyLoading={true}
                objectFit={'contain'}
                sizes={'(min-width: 1306px) 80vw, (min-width: 1600px) 1600px, 100vw'}
                srcSetWidths={[800, 1600, 2400, 3200]}
                thumbnail={thumbnail}
                video={video}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Modal>
  )
}
